import { Breadcrumb, Button, Steps } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { _adr } from "../../../address";
import { complexDigitToman, convertToJalaliWithTime, formatTime } from "../../../tools/tools";
import OprationResult from "../opration/opration";
import Profile from "../../corporate_subscriber_search/corporate/profile/profile";
import "./shop.scss";

/**
 * Frame shared by the charge / package / bill purchase steps.
 *
 * title    page title and breadcrumb
 * prefix   legacy class prefix ("dc" -> container-dc, dc-container) so the existing page styles keep applying
 * steps    wizard step titles; step = current index (omit both on pages without a wizard)
 * purchase subscriber picked in 360 / corporate search; shown as a profile card on top
 * footer   buttons under the page
 */
const ShopPage = ({ title, prefix, steps, step, purchase, footer, children }) => (
	<div className={`container-main container-${prefix} shop-page`}>
		<div className="g-hold-title-of-page">
			<Breadcrumb className="breadcrumbs" items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title }]} />
			<div className="title-page">
				<h3>{title}</h3>
			</div>
		</div>
		<div className="g-layout-content">
			<Content className={`g-layout-main ${prefix}-container`}>
				<div className="g-format-page">
					{purchase && (
						<>
							<Profile Profile={purchase} state />
							<br />
						</>
					)}
					<div className="g-body-format-page">
						{steps && (
							<div className="g-format-steps">
								<div className="holder-step">
									<Steps size="small" className="step-wizard" current={step} items={steps.map((s) => ({ title: s }))} />
								</div>
							</div>
						)}
						{children}
					</div>
					{footer && (
						<div className="g-footer-format-page">
							<div className="holder-button">{footer}</div>
						</div>
					)}
				</div>
			</Content>
		</div>
	</div>
);

export const toman = (value) => (
	<>
		<span dir="ltr">{complexDigitToman(value)}</span> تومان
	</>
);

/**
 * Red side card that sums up the order while it is being filled (same look as the dashboard hero / wallet banner).
 * rows [label, value]; total [label, value] shown large at the bottom; action = the continue button
 * wide: one horizontal bar pinned above a long list (package cards) instead of a side card
 */
export const ShopSummary = ({ title = "خلاصه خرید", msisdn, rows = [], total, action, empty, wide = false, showMsisdn = true }) => (
	<aside className={wide ? "shop-summary wide" : "shop-summary"}>
		<img className="shop-summary-decor" src={process.env.PUBLIC_URL + process.env.REACT_APP_PATH + "/assets/images/logo-small.png"} alt="" aria-hidden="true" />
		<h3>{title}</h3>
		{showMsisdn && (
			<div className="sum-msisdn">
				<i className="icon-simcard" />
				{msisdn ? <span dir="ltr">{msisdn}</span> : <span className="sum-placeholder">شماره موبایل</span>}
			</div>
		)}
		{empty ? (
			<p className="sum-empty">{empty}</p>
		) : (
			<>
				<ul>
					{rows.map(([label, value]) => (
						<li key={label}>
							<span>{label}</span>
							<b>{value}</b>
						</li>
					))}
				</ul>
				{total && (
					<div className="sum-total">
						<span>{total[0]}</span>
						<strong>{total[1]}</strong>
					</div>
				)}
			</>
		)}
		{action}
	</aside>
);

// receipt after a successful purchase; rows are [label, value]
export const ShopReceipt = ({ title, prefix, purchase, rows }) => (
	<ShopPage
		title={title}
		prefix={prefix}
		purchase={purchase}
		footer={
			<Button className="btn-normal btn-print" onClick={() => window.print()} type="default" icon={<i className="icon-print"></i>}>
				چاپ فاکتور
			</Button>
		}>
		<OprationResult
			isSucess={true}
			list={[
				[
					"تاریخ و ساعت",
					<span dir="ltr">
						{convertToJalaliWithTime(new Date().toISOString())} - {formatTime(new Date())}
					</span>,
				],
				...rows,
			].map(([label, value]) => ({ label, value }))}
		/>
	</ShopPage>
);

export default ShopPage;
